class Event {
  _init = async () => {
    return true
  }
  resolve = async (event, data = null) => {
    let _event = {}
    if (!event.type) {
      event = {
        type: event,
        detail: data
      }
    }

    if (["playing", "ended", "pause", "error"].indexOf(event.type) >= 0) {
      let tempName
      switch (event.type) {
        case "playing":
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "pause":
          tempName = "mediaPaused"
          break
        default:
          tempName = "mediaError"
          break
      }
      _event.name = tempName
    } else if (event.type === "stopped") {
      _event.name = "mediaStopped"
    } else if (event.type === "power") {
      _event.name = "power"
      _event.data = event.detail
    } else if (event.type === "source") {
      _event.name = "source"
      _event.data = event.detail
    }
    return _event
  }
}

export default Event
